import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'

import { ICReportTablePrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { diversifiers } from '@/react-query/queries/ic-report/hooks'

const percentageFormatter = numberFormatter({
  suffix: '%',
  transformer: (val) => val * 100,
})

const colDefs = createColDefs([
  {
    field: 'index',
  },
  {
    field: 'contribution_perf',
    headerName: 'Contribution Performance',
    valueFormatter: percentageFormatter,
  },
  {
    field: 'position_weight',
    headerName: 'Position Weight',
    valueFormatter: percentageFormatter,
  },
  {
    field: 'label_perf',
    headerName: 'Label Performance',
    valueFormatter: percentageFormatter,
  },
])

export interface PerfContributionTableProps extends ICReportTablePrimitive {}

export const PerfContributionTable: React.FC<PerfContributionTableProps> = ({
  params,
  options,
}) => {
  const query = diversifiers.useContribution(params)
  const data = query.data ?? []

  return <CustomAgGrid rowData={data} columnDefs={colDefs} loading={query.isLoading} {...options} />
}
